import FitSlider from "../../packs_helper/scripts/FitSlider";

const fitSlider = document.querySelector('.fit-slider');
if(fitSlider){
	FitSlider(fitSlider);
}

const categories = document.querySelectorAll('.category-buttons > nav > a');
const section = document.createElement('SECTION');
section.classList.add('container');
section.id = 'filtered-categories';

// const header = document.createElement('HEADER');
// const h2 = document.createElement('H2');
// header.appendChild(h2);
// section.appendChild(header)


// const header = document.createElement('header');
// const h2 = document.createElement('h2');
// h2.innerText = ''
const grid = document.createElement('DIV');
if(document.body.dataset.layout === 'mobile'){
	grid.classList.add('grid-2');
}
else{
	grid.classList.add('grid-6');
	grid.classList.add('grid-6-center');
}
section.appendChild(grid);

const hrsc = document.createElement('SECTION');
hrsc.className = 'container';
const hr = document.createElement('HR');
hrsc.append(hr);

const bazaarCategoriesList = document.getElementById('bazaar-categories-list');
const bazaarCategoriesListSeperator = document.getElementById('bazaar-categories-list-seperator');

[...categories].forEach(function(category){
	category.addEventListener('click', e => {
		e.preventDefault();
		const type = category.dataset.type;
		// h2.innerText = category.innerText + ' Kategorileri';
		[...categories].forEach(c => c.classList.remove('active'));
		[...grid.children].forEach(c => c.remove());
		category.classList.add('active');
		if(!type){
			section.remove();
			hrsc.remove();
			bazaarCategoriesList.classList.remove('d-none');
			bazaarCategoriesListSeperator.classList.remove('d-none');
		}
		else{
			const categoryBoxes = document.querySelectorAll('.category[data-type="'+type+'"]');
			[...categoryBoxes].forEach(categoryBox => {
				grid.appendChild(categoryBox.cloneNode(true));
			});
			document.querySelector('.category-buttons').after(section);

			section.after(hrsc);

			bazaarCategoriesList.classList.add('d-none');
			bazaarCategoriesListSeperator.classList.add('d-none');
		}
	})
})
